export enum CollectionName {
  DEVICES = "devices",
  EMERGENCY_CONTACTS = "emergencyContacts",
  CONTACT_GROUPS = "contactGroups",
  INCIDENTS = "incidents",
  SCENARIOS = "scenarios",
  USER_DATA = "userData",
}
